import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Carousel, { CarouselItem } from '../Carousel';
import Blockquote from 'tbk-components/src/components/Blockquote';

export interface ITestimonial {
	/**
	 * @control textarea
	 */
	text?: string;
	author?: string;
}

export interface ITestimonialsCarouselProps extends IBaseElementProps {
	testimonials?: ITestimonial[];
}

/**
 * Testimonials Carousel
 * @block
 * @requiresHooks
 * @icon align-center
 */

const TestimonialsCarousel: React.FC<ITestimonialsCarouselProps> = ({
	testimonials = [],
}) => (
	<div className={cn('testimonials-carousel')}>
		<Carousel showArrows>
			{testimonials.length > 0 &&
				testimonials.map(({ text, author }, index) => (
					<CarouselItem key={index}>
						<Blockquote source={author}>{text}</Blockquote>
					</CarouselItem>
				))}
		</Carousel>
	</div>
);

export default TestimonialsCarousel;
